/** 数据中心 → 泡茶机数据 → 泡茶机物料（patch 152） */
export const TEA_MACHINE_MATERIAL_MENU_IDS = {
  page: 990412,
  /** coffee_menu parent en_name */
  parentEnName: 'dataOfTeaExtractorMachine'
}



// WEBPACK FOOTER //
// ./src/constants/teaMachineMaterial.js